import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { uploadStudiesRoute } from '~/paths';

export default function UploadStudyBreadcrumbWrapper() {
  // Wrapper component for generating a breadcrumb entry
  useBreadcrumb('routes/upload/model/study', 'Studies', uploadStudiesRoute());
  return <Outlet />;
}
